import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Header from "../../Layout/Header";
import { useTranslation } from "react-i18next";
import {
  Available,
  AvailableText,
  CustomerReviews,
  Faq,
  FormulatedByExperts,
  HereMainHeading,
  OrderNow,
  SelectYourGoal,
  TailoredToYou,
  TailoredToYouPre,
  TailoredToYouEmphasis,
  TailoredToYouPost,
  TailoredToYouDesc,
  TakeTheTestButton,
  ProductBuyNow,
  ProductBuyNowPrice,
  ProductPricePerDay,
  ProductFreeShippingStrikethrough,
  ProductQuizEyebrow,
  ProductQuizTrust,
} from "../../Constants";
import useSmartFornula from "../../hooks/useSmartFormula";
import useReviewStats from "../../hooks/useReviewStats";
import Tabs from "../Home/SmartFormulas/Tabs";
import SmartFormulaCarousel from "../Home/SmartFormulas/SmartFormulaCarousel";
import TickImg from "../../assets/FreeShippingTick.webp";
import useMeta from "../../hooks/useMeta";
import { saveMetaParamsBeforeRedirect } from "../../utils";
import OneMonth from "../../assets/smart-formulas/one-month.webp";
import SecureShippedVerifired from "../Home/SmartFormulas/SecureShippedVerifired";
import Ingredients from "../Home/SmartFormulas/Ingredients";
import HowToEnjoyAccordion from "../Home/SmartFormulas/HowToEnjoyAccordion";
import ProductSuggestionWhyRiise from "../Customer/ProductSuggestionWhyRiise";
import CustomLink from "../CustomLink";
import VeganComponent from "../Home/Vegan";
import HowToEnjoy from "../Customer/components/HowToEnjoy";
import ExpertSection from "../Customer/components/ExpertSection";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../features/langSlice";
import HighStandards from "../Home/HighStandards";
import BoomTestimonials from "../Customer/components/BoomTestimonials";
import MakeChoice from "../Home/MakeChoice";
import HereForYou from "../Customer/components/HereForYou";
import ReviewsMobile from "../Customer/components/ReviewsMobile";

const Product = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const { SMART_FORMULAS } = useSmartFornula();
  const { metaEvent } = useMeta();
  const navigate = useNavigate();
  const selectedLang = useSelector(selectCurrentLanguage);
  const reviewStats = useReviewStats();

  if (!Object.keys(SMART_FORMULAS).includes(slug)) {
    return <Navigate to="/404" replace />;
  }

  return (
    <>
      <Header />
      <div className="container t-py-4">
        <div className="t-flex t-flex-col md:t-flex-row md:t-gap-4 t-items-start t-justify-start">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-text-navy">
            {t(SelectYourGoal)}
          </h2>
          <Tabs
            data={SMART_FORMULAS}
            onClick={(item) => {
              console.log("onCLick");
              navigate(`/products/${item}`);
            }}
            activeFormula={slug}
            isProductPage
          />
        </div>
      </div>
      <div className="container !t-pb-8">
        <div className=" t-mx-auto t-flex t-flex-col t-items-start t-justify-center md:t-flex-row t-gap-4 md:t-gap-12">
          <div className="t-w-full md:t-max-w-[500px]">
            <SmartFormulaCarousel
              images={SMART_FORMULAS[slug]?.images}
              isProductPage
            />
          </div>
          <div className="t-flex t-flex-col t-gap-4">
            <div className="t-flex t-flex-col">
              <h1 className="t-font-serif t-text-navy t-text-[28px] md:t-text-[36px] t-leading-tight t-italic">{SMART_FORMULAS[slug]?.heading}</h1>
              {reviewStats && (
                <div className="t-flex t-items-center t-gap-2">
                  <span className="t-text-butter t-text-base t-tracking-tight">★★★★★</span>
                  <p className="t-m-0 t-font-semibold t-text-sm t-text-navy">
                    {reviewStats.average}/5 ({reviewStats.count})
                  </p>
                </div>
              )}
              <p className="t-m-0">{SMART_FORMULAS[slug]?.desc}</p>
            </div>
            <div className="t-flex t-flex-col t-gap-4">
              {SMART_FORMULAS[slug]?.benefits?.map((benefit) => (
                <div className="t-flex t-items-center t-gap-4">
                  <img
                    src={TickImg}
                    alt=""
                    className="t-flex-none t-w-5 t-h-5"
                  />
                  <p className="!t-m-0">{benefit.desc}</p>
                </div>
              ))}
            </div>
            <div className="t-flex t-flex-col t-gap-3">
              <div className="t-flex t-items-end t-justify-between">
                <div className="t-flex t-flex-col t-gap-0.5">
                  <div className="t-flex t-items-baseline t-gap-2">
                    <h1 className="t-text-navy t-font-serif !t-font-normal t-text-[36px] !t-m-0">
                      {SMART_FORMULAS[slug]?.price}€
                    </h1>
                    <p className="t-m-0 t-text-gray-400 t-text-sm">
                      ({t(ProductPricePerDay, { amount: (SMART_FORMULAS[slug]?.price / 30).toFixed(2) })})
                    </p>
                  </div>
                  <div className="t-flex t-items-center t-gap-2 t-text-sm">
                    <span className="t-line-through t-text-gray-400">
                      {(SMART_FORMULAS[slug]?.price + 4.90).toFixed(2)}€
                    </span>
                    <span className="t-text-quiz-teal t-font-semibold">
                      {t(ProductFreeShippingStrikethrough)}
                    </span>
                  </div>
                </div>
                <img src={OneMonth} alt="" className="t-h-16 t-ml-auto" />
              </div>
              <button
                onClick={async () => {
                  metaEvent("InitiateCheckout");
                  saveMetaParamsBeforeRedirect();
                  window.location.href = `${SMART_FORMULAS[slug]?.link}?client_reference_id=${slug}`;
                }}
                className="!t-bg-butter !t-text-navy !t-font-bold !t-text-base !t-py-3 !t-px-6 !t-rounded-lg !t-border-none hover:!t-opacity-90 !t-transition-opacity disabled:t-opacity-50 !t-w-full !t-tracking-wide"
              >
                {t(ProductBuyNowPrice, { price: SMART_FORMULAS[slug]?.price })}
              </button>
            </div>
            <div className="t-flex t-items-start t-gap-1 t-flex-row">
              <div className="t-flex-none t-w-3 t-h-3 t-bg-quiz-teal t-mt-[5px] t-rounded-full" />
              <p className="t-text-sm t-m-0 t-text-quiz-teal !t-font-bold">
                {t(Available)}&nbsp;
                <span className="t-text-sm t-mt-0 t-text-navy t-font-semibold">
                  - {t(OrderNow)}
                </span>
                <span className="t-text-sm t-mt-0 t-text-navy">
                  {t(AvailableText)}
                </span>
              </p>
            </div>
            <SecureShippedVerifired />
            <div className="t-flex t-flex-col t-gap-2">
              <Ingredients ingredients={SMART_FORMULAS[slug]?.ingredients} />
              <HowToEnjoyAccordion />
              <ProductSuggestionWhyRiise viewHalf hideQuizFaq />
            </div>
          </div>
        </div>
      </div>
      <div className="t-bg-navy t-px-6 t-pt-10 t-pb-14">
        <div className="t-w-full t-max-w-[560px] t-mx-auto t-flex t-flex-col t-items-center t-gap-6 t-text-center">
          <span className="t-text-butter t-text-[11px] t-font-bold t-tracking-[3px] t-uppercase">
            {t(ProductQuizEyebrow)}
          </span>
          <h2 className="t-text-[26px] md:t-text-[34px] t-font-serif t-font-normal t-text-white !t-m-0 t-leading-snug">
            {t(TailoredToYouPre)}{' '}
            <em className="t-italic t-text-butter">{t(TailoredToYouEmphasis)}</em>
            {' '}{t(TailoredToYouPost)}
          </h2>
          <p className="!t-m-0 t-text-white/70 t-text-[15px] t-leading-relaxed">
            {t(TailoredToYouDesc)}
          </p>
          <CustomLink
            to="/quiz"
            className="t-w-full t-max-w-[320px]"
            onClick={() => metaEvent("Lead")}
          >
            <span className="t-block t-w-full t-text-center t-bg-butter t-text-navy t-font-bold t-text-base t-tracking-wide t-py-4 t-px-6 t-rounded-lg hover:t-opacity-90 t-transition-opacity">
              {t(TakeTheTestButton)} →
            </span>
          </CustomLink>
          <p className="!t-m-0 t-text-white/40 t-text-[12px] t-tracking-wide">
            {t(ProductQuizTrust)}
          </p>
        </div>
      </div>
      <VeganComponent whiteBg />
      <div className="t-w-full t-max-w-[500px] t-mx-auto ">
        <HowToEnjoy
          className="!t-max-h-[400px] !t-max-w-[400px] t-mx-auto"
          isProductPage
        />
      </div>
      <div className="t-max-w-[800px] t-mx-auto t-flex t-flex-col t-gap-4 t-overflow-auto t-mt-8">
        <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-text-navy">
          {t(FormulatedByExperts)}
        </h2>
        <ExpertSection lang={selectedLang === "us" ? "en" : selectedLang} />
      </div>
      <HighStandards />
      <div className="container !t-max-w-[1100px] t-mx-auto t-flex t-flex-col t-gap-4 t-overflow-auto t-my-8">
        <BoomTestimonials />
      </div>
      <div className="t-bg-gray-100 t-pt-4">
        <div className="container t-bg-gray-100 t-flex t-flex-col t-gap-4 t-overflow-auto t-mt-4 md:t-min-h-[495px]">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-text-navy">
            {t(CustomerReviews)}
          </h2>
          <ReviewsMobile />
        </div>
      </div>
      <div className="t-w-full !t-max-w-[600px] t-mx-auto container t-flex t-flex-col t-gap-4 md:t-min-h-[464px]">
        <MakeChoice isProductPage />
      </div>
      <div className="container !t-max-w-[600px] t-flex t-flex-col t-gap-4 !t-my-8">
        <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-text-navy">
          {t(Faq)}
        </h2>
        <ProductSuggestionWhyRiise viewOtherHalf hideQuizFaq />
      </div>
      <section className="steps section-padding t-max-w-[700px] t-mx-auto !t-pb-8 !t-bg-white t-h-[400px] md:t-h-[412px] !t-px-4">
        <div className="t-mb-8">
          <h3 className="t-text-[24px] md:t-text-[30px] !t-text-center t-font-serif t-text-navy">
            {t(HereMainHeading)}
          </h3>
        </div>

        <HereForYou />
      </section>
    </>
  );
};

export default Product;
